import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useStore } from '../../../contexts/store-provider';
import IAddFactory from '../../../models/forms/IAddUpdateFactory';
import { IFormModalProps } from '../../../models/forms/IForm';
import DefaultModal from '../../../shared-components/modal/default-modal';
import { formatMessage } from '../../../translations/format-message';
import AddFactoryForm from '../forms/add-factory-form';
import UpdateFactoryForm from '../forms/edit-factory-form';
import './add-edit-factory.css';

const AddUpdateFactory = (props: IFormModalProps) => {
  const { factoryStore } = useStore();
  const {
    AddFactoryService,
    UpdateFactoryService,
    getFactoryByIdServiceState,
    GetFactoryByIdService,
    factoryDetails,
    addUpdateFactoryState,
    reset,
    resetGetFactoryDetail,
    resetAddUpdateFactoryState,
  } = factoryStore;

  const onSubmitForm = (values: any) => {
    let factoryDetails = {
      FactoryName: values.FactoryName.trim(),
      FactoryCity: values.FactoryCity.trim(),
      FactoryCountry: values.FactoryCountry.trim(),
      FactoryAddress: values.FactoryAddress.trim(),
      FactoryType: '1',
    };

    if (props.id < 0) {
      var obj: IAddFactory = {
        ...factoryDetails,
        IsActive: true,
        UserName: values.UserName.trim(),
        Email: values.Email.trim(),
        Password: values.Password.trim(),
        UserType: values.UserType,
        Comment: values.Comment.trim(),
        AccountStatus: values.AccountStatus,
        FactoryId: values.FactoryId.trim(),
        UserId: values.UserId.trim(),
      };
      AddFactoryService(obj);
    } else {
      var updateObj = {
        TenantId: props.id,
        ...factoryDetails,
      };
      UpdateFactoryService(props.id, updateObj);
    }
  };

  const onModalClosed = () => {
    resetGetFactoryDetail();
    reset();
    props.modalClosed();
  };

  useEffect(() => {
    if (props.id > 0) {
      GetFactoryByIdService(props.id);
    }
  }, []);

  useEffect(() => {
    if (addUpdateFactoryState.success) {
      resetAddUpdateFactoryState();
      if (props.id < 0) toast.success(formatMessage('added_success'));
      else toast.success(formatMessage('updated_success'));
      onModalClosed();
    }
  }, [addUpdateFactoryState.success]);

  return (
    <React.Fragment>
      <DefaultModal
        id={props.id}
        size="lg"
        addHeader="add_factory"
        updateHeader="update_factory"
        onModalClosed={onModalClosed}
        isLoading={addUpdateFactoryState.inProgress}
      >
        {props.id > 0 ? (
          <UpdateFactoryForm
            id={props.id}
            initialValues={factoryDetails}
            submitHandler={onSubmitForm}
            isLoading={
              addUpdateFactoryState.inProgress ||
              getFactoryByIdServiceState.inProgress
            }
            onModalClosed={onModalClosed}
          />
        ) : (
          <AddFactoryForm
            id={props.id}
            initialValues={factoryDetails}
            submitHandler={onSubmitForm}
            isLoading={addUpdateFactoryState.inProgress}
            onModalClosed={onModalClosed}
          />
        )}
      </DefaultModal>
    </React.Fragment>
  );
};

export default observer(AddUpdateFactory);
